import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

class AuthService {
  // Login
  async login(email, password) {
    try {
      const response = await axios.post(`${API_URL}/auth/login`, {
        email,
        password
      });

      if (response.data.success && response.data.token) {
        localStorage.setItem('adminToken', response.data.token);
        localStorage.setItem('adminUser', JSON.stringify(response.data.user));
        return { success: true, user: response.data.user };
      }

      return { success: false, message: response.data.message };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Login failed'
      };
    }
  }

  // Logout
  logout() {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
  }

  // Get current user
  getCurrentUser() {
    const userStr = localStorage.getItem('adminUser');
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (error) {
        return null;
      }
    }
    return null;
  }

  // Get token
  getToken() {
    return localStorage.getItem('adminToken');
  }

  // Check if user is authenticated
  isAuthenticated() {
    return !!this.getToken();
  }

  // Verify token
  async verifyToken() {
    try {
      const token = this.getToken();
      if (!token) return false;

      const response = await axios.get(`${API_URL}/auth/verify`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      return response.data.success;
    } catch (error) {
      this.logout();
      return false;
    }
  }

  // Change password
  async changePassword(currentPassword, newPassword) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        `${API_URL}/auth/change-password`,
        { currentPassword, newPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      return { success: true, message: response.data.message };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to change password'
      };
    }
  }
}

export default new AuthService();
